class ComplementaryRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.initRecommendations();
  }

  initRecommendations() {
    fetch(this.dataset.url)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement("div");
        html.innerHTML = text;
        const recommendations = html.querySelector(
          "complementary-recommendations",
        );

        if (recommendations && recommendations.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML;
        }
      })
      .catch((e) => {
        console.error(e);
      });
  }
}

customElements.define(
  "complementary-recommendations",
  ComplementaryRecommendations,
);
